const apiHost = ((window as { [env: string]: any })['env']?.apiUrl) || '';

export const environment = {
    production: false,
    API_URL: (apiHost ? 'https://' + apiHost : '') + '/rose-portal-service/api/v1.0/',
    API_AUTH_URL: (apiHost ? 'https://' + apiHost : '') + '/realms/rose-portal/',
    auth_client_id: 'rose-portal-ui',
    session_token_key: 'clk-rose-token-access',
    session_refresh_key: 'clk-rose-token-refresh',
    edgarKeycloak: {
        API_AUTH_URL: (apiHost ? 'https://' + apiHost : '') + '/realms/clicklease/',
        clientId: 'rose-portal-admin',
        grant_type: 'password'
    },
    googleMapsApiKey: ((window as { [env: string]: any })['env']?.googleMapsApiKey || 'AIzaSyAmFBmAO5pzO-dIyBPnWpJs7jH05PyIWSk'),
    paynearme: {
        siteIdentifier: (window as { [env: string]: any })['env']?.paynearme?.siteIdentifier || 'S1411678367',
        host: (window as { [env: string]: any })['env']?.paynearme?.host || 'paynearme-sandbox.com'
    },
}
